export enum LogLevel {
  Information = 0,
  Success = 1,
  Warning = 2,
  Error = 3,
}
